export default "__VITE_ASSET__hNwQ7naJ__"